__turbopack_context__.v({
  "column": "nQkpba_column",
  "courses": "nQkpba_courses",
  "explore": "nQkpba_explore",
  "explore-panel": "nQkpba_explore-panel",
  "explore-panel-header": "nQkpba_explore-panel-header",
  "explore-panel-list": "nQkpba_explore-panel-list",
  "explore-panel-title": "nQkpba_explore-panel-title",
  "featured": "nQkpba_featured",
  "featured-copy": "nQkpba_featured-copy",
  "featured-cta": "nQkpba_featured-cta",
  "featured-image": "nQkpba_featured-image",
  "featured-meta": "nQkpba_featured-meta",
  "featured-shade": "nQkpba_featured-shade",
  "featured-slide": "nQkpba_featured-slide",
  "featured-title": "nQkpba_featured-title",
  "filter-icon": "nQkpba_filter-icon",
  "filters": "nQkpba_filters",
  "group": "nQkpba_group",
  "page--flush": "nQkpba_page--flush",
  "section-header": "nQkpba_section-header",
  "section-title": "nQkpba_section-title",
  "see-all": "nQkpba_see-all",
  "see-all--below-md": "nQkpba_see-all--below-md",
  "see-all--from-md": "nQkpba_see-all--from-md",
  "see-all-icon": "nQkpba_see-all-icon",
  "title": "nQkpba_title",
  "visually-hidden": "nQkpba_visually-hidden",
});
